/*
  KI-Kennzeichnung für Bilder.

  Sucht alle Bilder, deren Alt-Text den Marker #ki enthält, entfernt den Marker
  aus dem sichtbaren Alt-Text und hängt oben rechts im Bild einen Badge an. Ein
  Klick darauf öffnet den Hinweis-Dialog.

  Bewusst zentral gelöst statt in jeder Section, damit auch nachgeladene Bilder
  erfasst werden: Warenkorb-Drawer, Quick-View, Suche, Slider und App-Inhalte.

  Markup und Texte: snippets/hess-ki-hinweis.liquid
  Styles: assets/hess-ki-hinweis.css
*/
(function () {
  'use strict';

  /* #ki oder #ai, Groß- und Kleinschreibung egal. Das \b verhindert Treffer
     in Wörtern wie #kirsche. #ai wird mit erkannt, weil Weglot Alt-Attribute
     übersetzt und aus #ki dabei still ein #ai werden kann. */
  var MARKER = /#(?:ki|ai)\b/i;
  var MARKER_ALL = /#(?:ki|ai)\b/gi;

  /* Elemente, die neben dem Bild im selben Container stehen dürfen, ohne dass
     wir auf den Wrapper-Fallback ausweichen müssen. */
  var PASSIVE_TAGS = {
    SOURCE: true,
    NOSCRIPT: true,
    SCRIPT: true,
    STYLE: true,
    TEMPLATE: true,
    LINK: true,
    META: true
  };

  var root = null;
  var template = null;
  var dialog = null;
  var minWidth = 120;
  var badges = new WeakMap();
  var sizeObserver = null;
  var scanQueued = false;
  var lastTrigger = null;

  function init() {
    root = document.querySelector('[data-hs-ki-root]');
    if (!root) return;

    template = root.querySelector('[data-hs-ki-source]');
    dialog = root.querySelector('[data-hs-ki-dialog]');
    if (!template || !dialog) return;

    var configured = parseInt(root.getAttribute('data-hs-ki-min-width'), 10);
    if (configured > 0) minWidth = configured;

    if (typeof ResizeObserver === 'function') {
      sizeObserver = new ResizeObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          syncVisibility(entries[i].target);
        }
      });
    }

    bindDialog();
    scan();
    watch();

    document.addEventListener('visibilitychange', syncAll);
  }

  /* ---------- Erkennung ---------- */

  function scan() {
    var images = document.querySelectorAll('img[alt*="#ki" i], img[alt*="#ai" i]');
    for (var i = 0; i < images.length; i++) {
      attach(images[i]);
    }
  }

  function attach(image) {
    if (root.contains(image)) return;

    var alt = image.getAttribute('alt') || '';
    if (!MARKER.test(alt)) return;

    /* Erst den Marker entfernen. Danach findet der Selektor in scan() das Bild
       nicht mehr, das hält die Schleife mit dem MutationObserver endlich. */
    var cleaned = cleanAlt(alt);
    if (cleaned !== alt) image.setAttribute('alt', cleaned);

    var existing = badges.get(image);
    if (existing && existing.isConnected) return;

    var anchor = findAnchor(image);
    if (!anchor) return;

    var badge = template.cloneNode(true);
    badge.removeAttribute('data-hs-ki-source');
    /* Die Vorlage trägt tabindex="-1", die echten Badges müssen dagegen
       per Tastatur erreichbar sein. */
    badge.removeAttribute('tabindex');
    badge.setAttribute('data-hs-ki-trigger', '');
    badge.hidden = true;
    anchor.appendChild(badge);

    image.setAttribute('data-hs-ki', '');
    badges.set(image, badge);
    syncVisibility(image);

    if (sizeObserver) sizeObserver.observe(image);
    if (!image.complete) {
      image.addEventListener('load', function () {
        syncVisibility(image);
      }, { once: true });
    }
  }

  function cleanAlt(alt) {
    return alt
      .replace(MARKER_ALL, ' ')
      .replace(/\s{2,}/g, ' ')
      .replace(/\s+([,.;:])/g, '$1')
      /* Stand der Marker zwischen zwei Satzzeichen, bleibt sonst etwas wie
         "Gong,, Detailaufnahme" stehen. Punkte bleiben außen vor, damit
         Auslassungspunkte heil bleiben. */
      .replace(/([,;])\s*(?=[,;])/g, '')
      .replace(/^[\s,;:.]+/, '')
      .replace(/[\s,;]+$/, '')
      .trim();
  }

  /* ---------- Verankerung ---------- */

  /* Anker ist grundsaetzlich das direkte Elternelement. Frueher wurde das Bild
     im Zweifel in einen span gewickelt. Das hat Bilder zerstoert, die selbst
     position: absolute sind: Die Inline-Box hatte keine Groesse, das Bild
     kollabierte auf 0 mal 0. Es wird deshalb nie mehr etwas umgebaut, der
     Badge wird stattdessen in syncVisibility rechnerisch aufs Bild gelegt. */
  function findAnchor(image) {
    var parent = image.parentElement;
    if (!parent || parent === document.body) return null;

    /* Schon positioniert, also direkt brauchbar. Das ist der Normalfall im
       Theme, etwa .hs-mega-wissen__card-img oder responsive-image. */
    if (window.getComputedStyle(parent).position !== 'static') return parent;

    /* Ein nachtraegliches position: relative wuerde absolut positionierte
       Geschwister an diesen Container binden statt an ihren bisherigen
       Bezugspunkt. Gibt es solche, weichen wir nach oben aus. */
    if (!hasAbsoluteChild(parent, image)) {
      parent.classList.add('hs-ki-anchor');
      return parent;
    }

    var ancestor = parent.parentElement;
    for (var d = 0; ancestor && ancestor !== document.body && d < 4; d++) {
      if (window.getComputedStyle(ancestor).position !== 'static') return ancestor;
      ancestor = ancestor.parentElement;
    }

    parent.classList.add('hs-ki-anchor');
    return parent;
  }

  function hasAbsoluteChild(parent, image) {
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i] === image) continue;
      if (kids[i].hasAttribute('data-hs-ki-trigger')) continue;
      var pos = window.getComputedStyle(kids[i]).position;
      if (pos === 'absolute' || pos === 'fixed') return true;
    }
    return false;
  }

  function syncVisibility(image) {
    var badge = badges.get(image);
    if (!badge) return;

    var rect = image.getBoundingClientRect();
    badge.hidden = rect.width < minWidth;
    if (badge.hidden) return;

    /* Der Anker ist nicht zwingend deckungsgleich mit dem Bild. Deshalb den
       Versatz ausrechnen, damit der Badge auch dann in der rechten oberen
       Ecke des Bildes sitzt und nicht in der des Containers. */
    var anchor = badge.parentElement;
    if (!anchor) return;
    var box = anchor.getBoundingClientRect();
    var top = Math.max(0, Math.round(rect.top - box.top));
    var right = Math.max(0, Math.round(box.right - rect.right));

    badge.style.top = 'calc(' + top + 'px + var(--hs-ki-inset))';
    badge.style.right = 'calc(' + right + 'px + var(--hs-ki-inset))';
  }

  /* Der ResizeObserver liefert nur während laufender Frames aus, in
     Hintergrund-Tabs also gar nicht. Deshalb gibt es diesen zweiten Weg über
     das data-Attribut, der ohne Frames auskommt. */
  function syncAll() {
    var images = document.querySelectorAll('img[data-hs-ki]');
    for (var i = 0; i < images.length; i++) {
      syncVisibility(images[i]);
    }
  }

  /* ---------- Dialog ---------- */

  function bindDialog() {
    /* Capture-Phase, weil die Badges innerhalb der Produktkarten-Links sitzen.
       Ohne das würde ein Klick auf den Badge die Produktseite öffnen. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var trigger = target.closest('[data-hs-ki-trigger]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      lastTrigger = trigger;
      openDialog();
    }, true);

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    var close = dialog.querySelector('[data-hs-ki-close]');
    if (close) {
      close.addEventListener('click', function () {
        dialog.close();
      });
    }

    dialog.addEventListener('close', function () {
      if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
      lastTrigger = null;
    });
  }

  function openDialog() {
    if (dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  /* ---------- Nachgeladene Inhalte ---------- */

  function watch() {
    if (typeof MutationObserver !== 'function') return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.type === 'attributes') {
          /* Weglot schreibt Alt-Attribute nach der Übersetzung neu. */
          if (mutation.target.tagName === 'IMG') return queueScan();
          continue;
        }

        if (mutation.addedNodes.length) return queueScan();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['alt']
    });
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;

    var run = function () {
      if (!scanQueued) return;
      scanQueued = false;
      scan();
      syncAll();
    };

    /* Beide Wege anstoßen, der erste gewinnt. requestAnimationFrame pausiert
       in Hintergrund-Tabs, und genau dort laden Apps und Weglot trotzdem
       Bilder nach. Ohne den Timeout blieben die bis zum Tab-Wechsel
       ungekennzeichnet. */
    requestAnimationFrame(run);
    setTimeout(run, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
